/** The files upload fields take unless the field says otherwise: images (HEIC is converted to PNG once picked) and PDFs. */
export const ACCEPTED_FILE_TYPES = 'image/*, .heic, application/pdf';

/** Tells the user what to pick instead of a file accept rejected. */
export const rejectedUploadMessage = (accept = ACCEPTED_FILE_TYPES) =>
  accept.includes('application/pdf') ? 'Upload an image or a PDF' : 'Upload an image, such as a PNG or JPG';

/**
 * Whether a picked file matches accept, a list in the form of an HTML accept attribute. The input's accept attribute
 * only filters what the picker offers, and iOS's photo library offers videos for image/*, so the picked file is
 * checked too. Extensions match by name, which is how HEIC matches in browsers that give it no type.
 */
export const isAcceptedUpload = (file: File, accept = ACCEPTED_FILE_TYPES) =>
  accept
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
    .some((entry) => {
      if (entry.startsWith('.')) return file.name.toLowerCase().endsWith(entry);
      if (entry.endsWith('/*')) return file.type.startsWith(entry.slice(0, -1));
      return file.type === entry;
    });
